import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-header',
  imports: [RouterModule],
  standalone: true,
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  @Input('logo') logo: string =
    'https://bornprimitivetactical.com/cdn/shop/files/Badge_-_Black_70x@2x.png?v=1697644159';

  constructor() {}

  tryToScrollToShop() {
    if (typeof window !== 'undefined') {
      const element = document.getElementById('shop');
      console.log('element', element);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      } else {
        setTimeout(() => {
          const element = document.getElementById('shop');
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 300);
      }
    }
  }
}
